import { KnmTypeCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmTypeCodesEnum';
import { IKnm } from 'APIPackage/KnmModule/interfaces/IKnm';
import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';
import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';

import { approveRequiredSelectOption } from '../constants/approveRequiredSelectOptions';
import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';

export const convertApproveFormValuesToKnmData = (values: IKnmErknmForm, knmData?: IKnm): IKnm248['approve'] => {
  const {
    approved,
    approveRequired,
    approveNumberDecision,
    approveDateDecision,
    approveFioSigner,
    approveTitleSigner,
    approveNoteAppeal,
    rejectReasonType,
    approveAppeal: isApproveAppeal,
    approveDateRejectReason,
    approveNote,
    rejectReasonNote,
    approveStatus,
    typeErknm,
    approveFile,
    approveRemarks,
    isNeedApplyChangesInApprovedPlan,
    wasRejected,
  } = values;

  return {
    approved: approved?.value || null,
    approveRequired:
      typeErknm?.code === KnmTypeCodesEnum.PP ? approveRequiredSelectOption?.value : approveRequired?.value || null,
    approveNote: knmData?.knmErknm?.approve?.approveNote || null,
    dateDecision: convertFormDateValueToKnmDataDate(approveDateDecision) || null,
    numberDecision: approveNumberDecision || null,
    fioSigner: approveFioSigner || null,
    titleSigner: approveTitleSigner || null,
    noteAppeal: approveNoteAppeal || null,
    status: approveStatus || null,
    rejectReasonType: rejectReasonType ? deleteObjectProperties(rejectReasonType, ['label', 'value']) : null,
    rejectReasonNote: rejectReasonNote || null,
    dateRejectReason: convertFormDateValueToKnmDataDate(approveDateRejectReason),
    prosecutorRegStatus: knmData?.knmErknm?.approve?.prosecutorRegStatus || null,
    note: approveNote || null,
    appeal: typeof isApproveAppeal === 'boolean' ? isApproveAppeal : null,
    approveFile: approveFile || null,
    isNeedApplyChangesInApprovedPlan: isNeedApplyChangesInApprovedPlan || null,
    wasRejected: wasRejected || null,
    remarks:
      approveRemarks?.map(remarkItem => ({
        guid: remarkItem.guid || null,
        section: remarkItem.sectionCode,
        remarkId: typeof remarkItem.remark?.value === 'number' ? remarkItem.remark.value : null,
        description: remarkItem.description || null,
        changes: remarkItem.changes || null,
      })) || null,
  };
};
